/* eslint-disable import/prefer-default-export */

import { API_URL } from '../../../../../../../utils/config';

export const SNMP_CACTI_URL = `${API_URL}/snmpCacti`;
